export function slugify(value: string) {
    if (!value)
        return undefined;

    return value.toLowerCase()
        .replaceAll(/\b(?:a|an|the|and|or)\b/g, '')
        .replaceAll(/[^\w-\s]/g, '')
        .replaceAll(/\s+/g, '-');
}
